import { isStaticList } from "app/pages/sales-intelligence/domain/lists/utils/list-variant";
import type { LeadsSearchColumnListConfig, LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import { getLeadsSearchColumnListConfig } from "app/pages/sales-intelligence/modules/leads-search/configuration/columns/columnsConfig";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import {
    crmListsColumnConfig,
    listsColumnConfig,
} from "app/pages/sales-intelligence/pages/opportunity-list/configuration/columns/columnsConfig";

export const useListsColumnsConfig = (activeLeadsType: LeadsType): LeadsSearchColumnListConfig => {
    const listParams = useListParams();

    if (activeLeadsType === "companies") {
        return isStaticList(listParams) ? listsColumnConfig : crmListsColumnConfig;
    }

    return getLeadsSearchColumnListConfig();
};
